module.exports = __webpack_public_path__ + "static/img/13.37a9443.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/5/zh/13.png
// module id = PRci
// module chunks = 0